import { createAction } from 'redux-actions';
import { callApi, getEndpoint } from '../../../../utils/api';
const CONFIRM_CONTRIBUTION_WINDOW = 'CONFIRM_CONTRIBUTION_WINDOW';
const IRA_LIMIT = 'IRA_LIMIT';
const MINOR_IRA_LIMIT = 'MINOR_IRA_LIMIT';

export const defaultState = {
  isLoading: false,
  isLoaded: false,
  hasFailed: false,
  windowCheckLoading: false,
  windowCheckFailed: false,
  windowCheck: {},
  error: null,
  data: {
    /*
  'currentYearMaximumLimit': 5500,
  'currentYearContributionsSoFar': 0,
  'currentYearRemainingContributions': 500,
  'currentYearRemainingAutomaticPurchases': 500,
  'priorYearMaximumLimit': 5500, 'priorYearContributionsSoFar': 0,
  'priorYearRemainingContributions': 3000,
  'priorYearRemainingAutomaticPurchases': 0,
  'willExceedLimitAtEndOfYearWithNoChanges': true,
  'withinIRAPriorYearContributionPeriod': true,
  'alreadyReachedLimit': false */
  },
  minorData: [{}],
};

export default function IRALimit(state = defaultState, { payload, type }) {
  switch (type) {
    case `${IRA_LIMIT}_PENDING`:
      return {
        ...state,
        isLoaded: false,
        isLoading: true,
      };
    case `${IRA_LIMIT}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        data: payload.body,
      };
    case `${IRA_LIMIT}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        isLoaded: false,
        hasFailed: true,
        // error: payload
      };
    case `${MINOR_IRA_LIMIT}_PENDING`:
      return {
        ...state,
        isLoaded: false,
        isLoading: true,
      };
    case `${MINOR_IRA_LIMIT}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        minorData: payload.body ? payload.body : [{}],
      };
    case `${MINOR_IRA_LIMIT}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        isLoaded: false,
        hasFailed: true,
        // error: payload
      };
    case `${CONFIRM_CONTRIBUTION_WINDOW}_PENDING`:
      return {
        ...state,
        windowCheckLoading: true,
      };
    case `${CONFIRM_CONTRIBUTION_WINDOW}_FULFILLED`:
      return {
        ...state,
        windowCheckLoading: false,
        windowCheck: payload.body,
        /* Sample body:
            {
              "iraContributionPeriodCutoffDate": "04-05-2018",
              "priorYear": 2017,
              "currentYear": 2018,
              "withinPriorYearContributionPeriod": false
            }
         */
      };
    case `${CONFIRM_CONTRIBUTION_WINDOW}_REJECTED`:
      return {
        ...state,
        windowCheckLoading: false,
        windowCheckFailed: true,
      };
    default:
      return state;
  }
}

export const getIRALimit = () => {
  return () => {
    return createAction(IRA_LIMIT)(callApi(getEndpoint('IRALimit')));
  };
};

export const getMinorIRALimit = () => {
  return () => {
    return createAction(MINOR_IRA_LIMIT)(callApi(getEndpoint('minorIRALimit')));
  };
};

export const getContributionWindow = (stateCode) => {
  return createAction(CONFIRM_CONTRIBUTION_WINDOW)(
    callApi(getEndpoint('contributionWindow', { path: stateCode || 'MD' }))
  );
};
